module.exports = __webpack_public_path__ + "img/cbhq.7dc96c23.jpg";